import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { resetPassword } from "../api/api.js";

function ResetPassword() {
    const [searchParams] = useSearchParams();
    const code = searchParams.get("code");
    const [newPassword, setNewPassword] = useState("");
    const [status, setStatus] = useState(null);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newPassword) {
            setError("Please enter your new password.");
            return;
        }

        setStatus("loading");
        setError("");

        try {
            const response = await resetPassword(code, newPassword);
            if (response.status === "success") {
                setStatus("reset");
            } else {
                setStatus("failed");
                setError("Password reset failed. Please try again.");
            }
        } catch (error) {
            setStatus("failed");
            setError("An error occurred. Please try again later.");
        }
    };

    return (
        <div className="password-reset-container">
            {status === "reset" ? (
                <p>Password successfully reset! ✅</p>
            ) : (
                <form onSubmit={handleSubmit} className="reset-form">
                    <h2>Set New Password</h2>
                    {error && <p className="error-message">{error}</p>}
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        className="password-input"
                    />
                    <button type="submit"
                        disabled={status === "loading"}
                        className="auth-submit-btn"
                    >
                        {status === "loading" ? "Resetting..." : "Submit"}
                    </button>
                    {status === "failed" && <p className="error-message">Password reset failed. ❌</p>}
                </form>
            )}
        </div>
    );
}

export default ResetPassword;
